/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Subtitle Import" |
*
* @param {Subtitle_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_title = /** @type {((inputs?: Subtitle_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕インポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de legendas")
	return /** @type {LocalizedString} */ ("Subtitle Import")
});